import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Form } from 'semantic-ui-react'
import styled from 'styled-components'
import { FarmersService } from '~/api/services/farmers'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import { LIGHT_USER_ROLE_SLUG } from '~/Constants'
import { useAuth } from '~/routes/components/AuthProvider'
import { handleErrors } from '~/utils/helpers'

const Wrapper = styled.div`
display: flex;
align-items: flex-start;
min-height: 200px;
gap: 10px;
 .field {
   margin: 0px!important;
 }
 .button {
   margin-left: 0px !important;
   margin-bottom: 10px !important;
 }
`

const TaxData: React.FC = () => {
  const { systemData: { logged: { roleSlug } } } = useAuth()
  const { t } = useTranslation()
  const { id } = useParams()
  const lightUserLogged = roleSlug === LIGHT_USER_ROLE_SLUG

  const [taxNumber, setTaxNumber] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsLoading(true)
    try {
      const response = await FarmersService.getTaxData(id)
      setTaxNumber(response.data.taxNumber)
    } catch (error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  async function handleUpdateTaxNumber() {
    setIsLoading(true)
    try {
      await FarmersService.updateTaxData(id, { taxNumber })
      notify(t('Successfully update tax number'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  return <Wrapper>
    <Form.Input
      label={t('Tax number')}
      disabled={lightUserLogged || isLoading}
      style={{ marginLeft: 0, margin: 10 }}
      loading={isLoading}
      value={taxNumber}
      onChange={(e, { value }) => setTaxNumber(value)}
      placeholder={t('Enter tax number')}
    />
    <El.PageHeaderActionButton
      style={{ magin: 0, marginTop: 27 }}
      loading={isLoading}
      disabled={isLoading || lightUserLogged}
      onClick={() => handleUpdateTaxNumber()}
    >{t('Update')}</El.PageHeaderActionButton>
  </Wrapper>
}
export default TaxData